import React, { useState } from 'react';
import Scrollbar from 'react-scrollbars-custom';
import { IApiEmployee } from 'next-common';
import { DealerSelect } from './SubMenus';
import { SettingsFooter } from './SettingsFooter';
import { SettingsHeader } from './SettingsHeader';
import { IUserSubMenu, UserSubMenu, userSubMenus } from './UserSubMenus';
import { SettingsItem } from './SettingsItem';
import { cn } from 'types';

export interface IUserSettingsProps {
  employee: IApiEmployee;
  setModal(value: boolean): void;
  isMarginerPage?: boolean;
}

export const UserSettings = (props: IUserSettingsProps) => {
  const [selected, setSelected] = useState<IUserSubMenu>();
  const popupClass = props?.isMarginerPage ? 'user-profile-popup-marginer' : 'user-profile-popup-next';
  return (
    <div className="absolute top-[3.75rem] right-[1.75rem] z-[99]">
      <div
        className={cn(
          'bg-white flex flex-col rounded-xl w-[230px] z-[100] overflow-hidden shadow-[0_2px_5px_rgba(0,0,0,0.1)]',
          props?.isMarginerPage ? 'h-[400px]' : 'h-full'
        )}
      >
        <SettingsHeader selected={selected} onClose={() => props.setModal(false)} onReset={() => setSelected(null)} />
        {props?.isMarginerPage && (
          <Scrollbar className="py-3 overflow-y-auto">
            <div>
              {!selected && (
                <div className="flex flex-col">
                  {userSubMenus.map((item) => (
                    <SettingsItem key={item.key} item={item} onSelect={() => setSelected(item)} />
                  ))}
                </div>
              )}
              {selected?.key === UserSubMenu.DEALERS && (
                <DealerSelect employee={props.employee} onSelect={() => setSelected(null)} />
              )}
            </div>
          </Scrollbar>
        )}
        <SettingsFooter employee={props.employee} />
      </div>
    </div>
  );
};
